import {
  ApiResponse,
  CreateSlotType,
  DateSearchParams,
  ReserveSlotsType,
  SlotDto,
  UnreserveSlotsType,
  UpdateSlotType,
} from '../../types/types';
import { client } from '../client';
import { urls } from '../endpoints';

export const getSlotsByCourtIdRequest = async (
  courtId: number,
  params?: DateSearchParams & { availableOnly?: boolean },
) => {
  try {
    const response = await client.get<ApiResponse<SlotDto[]>>(
      urls.getSlotsByCourtId(courtId, params),
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return null;
  }
};

export const createSlotsRequest = async (slots: CreateSlotType) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.createMultipleSlots,
      slots,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateSlotsRequest = async (slot: UpdateSlotType) => {
  try {
    const response = await client.put<ApiResponse<number>>(
      urls.updateSlot(slot.slotId),
      slot,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSlotRequest = async (slotId: number) => {
  try {
    const response = await client.delete<ApiResponse<number>>(
      urls.deleteSlot(slotId),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const reserveSlotsRequest = async (data: ReserveSlotsType) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.reserveSlots,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const unreserveSlotsRequest = async (data: UnreserveSlotsType) => {
  try {
    const response = await client.post<ApiResponse<number>>(
      urls.unreserveSlots,
      data,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
